/**
 * Claves de localStorage de Fina Pago (compartidas entre el modal de activación, Cuentas bancarias
 * y la píldora de la topbar). Viven en app-common para que la topbar no dependa de bank-accounts.
 */

/** «Ahora no» en la intro/promo → aparece la píldora «Activar Fina Pago» en la topbar. */
export const FINA_PAGO_INTRO_DISMISSED_KEY = 'fina-pago-intro-dismissed';

/** El hero promocional se muestra una vez por comercio (`<key>:<tenantId>`). */
export const FINA_PAGO_PROMO_SEEN_KEY = 'fina-pago-promo-seen';

export function isFinaPagoIntroDismissed(): boolean {
    try {
        return localStorage.getItem(FINA_PAGO_INTRO_DISMISSED_KEY) === '1';
    } catch {
        return false;
    }
}
